'use client';

import { UTCDate } from '@date-fns/utc';
import type { SupportedGame } from '@/config/supportedGames';
import { BettablePickemsHead } from './BettablePickemsHead';
import { BettablePickemsList } from './BettablePickemsList';
import { BettablePickemsStatus } from './BettablePickemsStatus';
import { PickemBetsTabs } from './PickemBetsTabs';
import { PickemsBettingSkeleton } from './PickemsBettingSkeleton';
import { usePickems } from './usePickems.hook';

export const PickemsBetting = ({
  date = new UTCDate(),
  game,
}: {
  game: SupportedGame;
  date?: UTCDate;
}) => {
  const {
    pickems,
    selectedPickems,
    isLoading,
    handleSelect,
    handleClearAll,
    totalPickems,
  } = usePickems({ game, date });

  const handleSubmitSuccess = () => {
    handleClearAll();
  };

  if (isLoading) {
    return <PickemsBettingSkeleton />;
  }

  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-[1fr_23rem] lg:gap-5">
        <div className="rounded-lg bg-dark-gray px-4 py-6">
          <BettablePickemsHead date={date} totalPickems={totalPickems} />
          <BettablePickemsStatus pickems={pickems} />
          <BettablePickemsList
            onSelect={handleSelect}
            pickems={pickems}
            selectedPickems={selectedPickems}
          />
        </div>

        <div className="flex flex-col gap-4 rounded-lg bg-card-bg px-5 py-8">
          <PickemBetsTabs
            game={game}
            onClearAll={handleClearAll}
            onRemove={(pickemId) => handleSelect(pickemId, '')}
            onSuccess={handleSubmitSuccess}
            selectedPickems={selectedPickems}
            totalPickems={totalPickems}
          />
        </div>
      </div>
    </div>
  );
};
